import React, { Component } from "react";
import { Modal, Button, MenuItem, Nav, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import _ from "underscore";
import LoaderPanel from "../components/LoaderPanel";
import ConfirmDropdown from "../components/ConfirmDropdown";
import TitlePage from "../components/TitlePage";
import withLoadSave from "../components/LoadSave";
import MenuNavbar from "../components/MenuNavbar";
import { EDTableSection, EDTable, EDTableRow, EDTabs } from "../components/EDDOM";
import { FormControlLabel } from "../components/FormControls";
import notify from "../utils/notify";

class Frontends extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showInviteModal: null,
      inviteto: '',
      invitefirstname: '',
      invitelastname: '',
      invitecompanyname: '',
      invitephone: '',
      invitesubject: '',
      invitenumcontacts: '',
    };
  }

  createClicked = () => {
    this.props.history.push("/frontends/edit?id=new"); 
  }

  deleteConfirmClicked = async id => {
    await axios.delete('/api/frontends/' + id);
    await this.props.reload();
  }

  onInvite = id => {
    this.setState({showInviteModal: id});
  }

  modalChanged = event => {
    this.setState({[event.target.id]: event.target.value});
  }

  inviteClose = async ok => {
    var frontend = this.state.showInviteModal;

    this.setState({showInviteModal: null});
  
    if (!ok) {
      return;
    }
  
    await axios.post('/api/invite', {
      email:       this.state.inviteto,
      firstname:   this.state.invitefirstname,
      lastname:    this.state.invitelastname,
      companyname: this.state.invitecompanyname,
      phone:       this.state.invitephone,
      subject:     this.state.invitesubject,
      numcontacts: this.state.invitenumcontacts,
      frontend:    frontend,
    });

    notify.show('Signup message sent', "success");
  }

  switchView = url => {
    this.props.history.push(url);
  }

  render() {
    let minWidth = '600px';
    let maxWidth = '1024px';

    return (
      <MenuNavbar {...this.props} isAdmin={true}>
        <TitlePage title="Advanced Frontend Configuration" button={
          <Button bsStyle="primary" onClick={this.createClicked}>Add New Configuration</Button>
        } tabs={
          <EDTabs>
            <Nav className="nav-tabs space15" activeKey="1">
              <NavItem eventKey="1" disabled>Frontend Configurations</NavItem>
              <NavItem eventKey="2" onClick={this.switchView.bind(null, "/gallerytemplates")}>Broadcast Templates</NavItem>
              <NavItem eventKey="3" onClick={this.switchView.bind(null, "/formtemplates")}>Form Templates</NavItem>
            </Nav>
          </EDTabs>
        } />
        <Modal show={this.state.showInviteModal !== null}>
          <Modal.Header>
            <Modal.Title>
              Send Signup Message
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormControlLabel
              id="invitefirstname"
              obj={this.state}
              label="First Name"
              onChange={this.modalChanged}
            />
            <FormControlLabel
              id="invitelastname"
              obj={this.state}
              label="Last Name"
              onChange={this.modalChanged}
              space
            />
            <FormControlLabel
              id="invitecompanyname"
              obj={this.state}
              label="Organization Name"
              onChange={this.modalChanged}
              space
            />
            <FormControlLabel
              id="invitephone"
              obj={this.state}
              label="Phone Number"
              type="tel"
              onChange={this.modalChanged}
              space
            />
            <FormControlLabel
              id="invitenumcontacts"
              obj={this.state}
              label="Number of Contacts"
              onChange={this.modalChanged}
              space
            />
            <FormControlLabel
              id="inviteto"
              obj={this.state}
              label="Email Address"
              onChange={this.modalChanged}
              type="email"
              space
            />
            <FormControlLabel
              id="invitesubject"
              obj={this.state}
              label="Subject"
              onChange={this.modalChanged}
              space
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.inviteClose.bind(this, true)} bsStyle="primary" disabled={!this.state.inviteto || !this.state.invitesubject || !this.state.invitefirstname || !this.state.invitelastname}>Send</Button>
            <Button onClick={this.inviteClose.bind(this, false)}>Cancel</Button>
          </Modal.Footer>
        </Modal>
        <LoaderPanel isLoading={this.props.isLoading}>
          <EDTableSection>
          {
            this.props.data.length ?
              <EDTable className="growing-margin-left" minWidth={minWidth} maxWidth={maxWidth}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th></th>
                  </tr>
                </thead>
                {
                  _.map(this.props.data, (f, index) =>
                    <EDTableRow key={f.id} index={index}>
                      <td>
                        <ul className="list-inline">
                          <li>
                            <h4 className="name-padded">
                              <Link to={'/frontends/edit?id=' + f.id}>
                                {f.name}
                              </Link>
                            </h4>
                          </li>
                        </ul>
                      </td>
                      <td className="last-cell">
                          <ConfirmDropdown
                            id={f.id + '-split'}
                            menu="Delete"
                            extra={true}
                            title="Delete Confirmation"
                            prompt={"Are you sure you wish to delete '" + f.name + "'?"}
                            onConfirm={this.deleteConfirmClicked.bind(this, f.id)}
                            text="Actions">
                            <MenuItem onClick={() => this.props.history.push('/frontends/edit?id=' + f.id)}>Edit</MenuItem>
                            <MenuItem onClick={this.onInvite.bind(null, f.id)}>Send Signup Message</MenuItem>
                          </ConfirmDropdown>
                       </td>
                     </EDTableRow>
                  )
                }
              </EDTable>
              :
              <div className="text-center space-top-sm">
                <h3>No frontends configured!</h3>
                <h4>Frontends are what your customers see when they log in to EmailDelivery.com</h4>
              </div>
          }
          </EDTableSection>
        </LoaderPanel>
      </MenuNavbar>
    );
  }
}

export default withLoadSave({
  extend: Frontends,
  initial: [],
  get: async () => _.sortBy((await axios.get('/api/frontends')).data, f => f.name.toLowerCase())
});




// WEBPACK FOOTER //
// ./src/containers/Frontends.js